import { useTimer } from "react-timer-hook";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";

const Timer = forwardRef(
  ({ expiryTimestamp, setTestComplete, endTest }, ref) => {
    const [startTime, setStartTime] = useState(null); // Initially null
    const [elapsedTime, setElapsedTime] = useState({
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    const {
      seconds,
      minutes,
      hours,
      isRunning,
      start,
      pause,
      resume,
      restart,
    } = useTimer({
      expiryTimestamp,
      autoStart: false,
      onExpire: () => {
        setTestComplete(true);
        pause();
        endTest();
      },
    });

    // Update elapsed time every second when the timer is running
    useEffect(() => {
      let intervalId;

      if (isRunning && startTime) {
        intervalId = setInterval(() => {
          const timeElapsed = Math.floor((Date.now() - startTime) / 1000); // Time passed in seconds

          const elapsedHours = Math.floor(timeElapsed / 3600);
          const elapsedMinutes = Math.floor((timeElapsed % 3600) / 60);
          const elapsedSeconds = timeElapsed % 60;

          setElapsedTime({
            hours: elapsedHours,
            minutes: elapsedMinutes,
            seconds: elapsedSeconds,
          });
        }, 1000);
      }

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }, [isRunning, startTime]);

    const formatElapsedTime = () => {
      return `${String(elapsedTime.hours).padStart(2, "0")}:${String(
        elapsedTime.minutes
      ).padStart(2, "0")}:${String(elapsedTime.seconds).padStart(2, "0")}`;
    };

    const elapsedUpdate = () => {
      return (
        elapsedTime.hours * 3600 +
        elapsedTime.minutes * 60 +
        elapsedTime.seconds
      );
    };

    useImperativeHandle(ref, () => ({
      start: () => {
        setStartTime(Date.now()); // Set the start time when the timer starts
        start();
      },
      pause,
      resume,
      restart,
      getElapsedTime: formatElapsedTime,
      getElapsedUpdate: elapsedUpdate,
    }));

    return (
      <div style={{ textAlign: "center" }}>
        <span>{String(hours).padStart(2, "0")}</span>:
        <span>{String(minutes).padStart(2, "0")}</span>:
        <span>{String(seconds).padStart(2, "0")}</span>
      </div>
    );
  }
);

export default Timer;
